module.exports = __webpack_public_path__ + "static/media/9.6fa66838.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/9.png
// module id = 1047
// module chunks = 0